import { render } from "./UserInterest.vue?vue&type=template&id=4221d37b"
import script from "./UserInterest.vue?vue&type=script&lang=js"
export * from "./UserInterest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__